import { createTheme } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';

// Colours taken from semmcolps.com.
const BG = '#272727';
const PAPER = '#1F1F1F';
const ACCENT = '#7DDF9E';
const DIVIDER = '#3A3A3A';
const HEADER_BG = '#2E2E2E';
const ROW_HOVER = 'rgba(125, 223, 158, 0.08)';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: ACCENT, contrastText: PAPER },
    background: { default: BG, paper: PAPER },
    text: { primary: '#FFFFFF', secondary: '#B5B5B5' },
    divider: DIVIDER,
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Mulish","Segoe UI","Helvetica Neue","Arial",sans-serif',
    h4: { fontWeight: 600, fontSize: '1.4rem', '@media (max-width:600px)': { fontSize: '1.15rem' } },
    h5: { fontWeight: 600, fontSize: '1.1rem' },
    h6: { fontWeight: 600, fontSize: '1rem' },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiCard: { defaultProps: { variant: 'outlined' } },
    MuiTextField: { defaultProps: { size: 'small', fullWidth: true } },
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundColor: PAPER, color: '#FFFFFF', borderBottom: `1px solid ${DIVIDER}` },
      },
    },
  },
});

export const dataGridSx: SxProps<Theme> = {
  border: `1px solid ${DIVIDER}`,
  backgroundColor: PAPER,
  '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader': { backgroundColor: HEADER_BG, fontWeight: 600 },
  '& .MuiDataGrid-row:hover': { backgroundColor: ROW_HOVER },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
};
